module.exports = __webpack_public_path__ + "static/media/YGR-Partner-Stamp.580b5da5.png";